import { BehaviorSubject } from 'rxjs';
import { environment } from "@env/environment";
import { tap } from "rxjs/operators";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class UsersService {
    constructor(http) {
        this.http = http;
        this.PROFILE_CODS = [
            { id: "student", description: "Estudante" },
            { id: "teacher", description: "Professor" },
        ];
        this._users = new BehaviorSubject([]);
        this.users$ = this._users.asObservable();
    }
    get(per_page = 10, page = 1, term = "") {
        return this.http.get(`${environment.base_url}/users?page=${page}&per_page=${per_page}&term=${term}`);
    }
    update(userId, formData) {
        return this.http.put(`${environment.base_url}/users/${userId}/update`, formData);
    }
    getUsersByRegisterDate(per_page = 10, page = 1, term = "") {
        return this.http.get(`${environment.base_url}/users/get_users_by_created_at?page=${page}&per_page=${per_page}&term=${term}`);
    }
    getExtract(userId, per_page = 10, page = 1) {
        return this.http.get(`${environment.base_url}/users/${userId}/extract_admin?page=${page}&per_page=${per_page}`);
    }
    getPixRequest(userId, per_page = 10, page = 1) {
        return this.http.get(`${environment.base_url}/users/${userId}/pix_request?page=${page}&per_page=${per_page}`);
    }
    getPendingPix() {
        return this.http.get(`${environment.base_url}/users/get_pending_pix`);
    }
    payRequest(id, paidDate) {
        return this.http.put(`${environment.base_url}/users/${id}/pay_request`, { paid_date: paidDate });
    }
    getAccess(userId, per_page = 10, page = 1) {
        return this.http.get(`${environment.base_url}/users/${userId}/access?page=${page}&per_page=${per_page}`);
    }
    getCountAccess(quantity = 10) {
        return this.http.get(`${environment.base_url}/users/access/count?quantity=${quantity}`);
    }
    getPartnershipSolicitations(per_page = 10, page = 1) {
        return this.http.get(`${environment.base_url}/users/partnership_solicitations`);
    }
    acceptPartnership(institutionId) {
        return this.http.get(`${environment.base_url}/users/${institutionId}/accept`);
    }
    getGuests(param = "") {
        return this.http.get(`${environment.base_url}/users?param=${param}`);
    }
    bulkMail(form) {
        return this.http.post(`${environment.base_url}/users/bulk_mail`, form);
    }
    parseProfileName(value) {
        const index = this.PROFILE_CODS.map((item) => item.id).indexOf(value);
        if (index > -1) {
            return this.PROFILE_CODS[index].description;
        }
        return "";
    }
    setPermissions(userId, institutionsName, isInstitution) {
        return this.http.put(`${environment.base_url}/users/${userId}/set_permissions`, { institution: institutionsName, is_institution: isInstitution });
    }
    getPermissions(userId) {
        return this.http.get(`${environment.base_url}/users/${userId}/get_permissions`);
    }
    deleteUser(userId) {
        return this.http.delete(`${environment.base_url}/users/${userId}/delete_user`).pipe(tap(() => {
            const currentUsers = this._users.getValue();
            const updatedUsers = currentUsers.filter(user => user.id !== userId);
            this._users.next(updatedUsers);
        }));
    }
    getRegisteredUsers() {
        return this.http.get(`${environment.base_url}/users/registered_users`);
    }
    updateWordsCount(userId, words) {
        return this.http.put(`${environment.base_url}/users/${userId}/update_words_count`, { words: words });
    }
    getWordsCount(userId) {
        return this.http.get(`${environment.base_url}/users/${userId}/get_words_count`);
    }
    getUserWordsById(userId) {
        return this.http.get(`${environment.base_url}/users/${userId}/get_user_words_count`);
    }
}
UsersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UsersService_Factory() { return new UsersService(i0.ɵɵinject(i1.HttpClient)); }, token: UsersService, providedIn: "root" });
